// V1-COMPAT: the name react18_component/react18_mount.js mount as "V1MediaProfileShow" -- the
// copied V2 MediaProfileTopLevelShow (media_profiles/media_profile_top_level_show.jsx) wrapped with
// the entity-resolution glue (with_v2_entity.jsx, resolving `media_profiles.migrate_id` to its V2
// `id`) and the V2 identity glue (with_v2_identity.jsx), so a signed-in V1 viewer gets the same
// identity-gated features V2 hosts itself. Mounted by Frontend::ReportersController#show once it
// resolves the :v2 render.
//
// The lookup is narrowed by `migrate_type` as well as `migrate_id`. V1's tables have independent id
// sequences whose values overlap, and a V2 media profile converted from another profile type keeps
// the migrate_type it was created with -- so a handful carry "PrUser" and a migrate_id out of V1's
// PrUser sequence, which can equal a real V1 Reporter id. Matching on migrate_id alone can
// therefore land on a different person's profile. Rows with no migrate_type at all are historical
// and are still Reporters, so they are admitted too.
import withV2Identity from './with_v2_identity';
import withV2Entity from './with_v2_entity';
import MediaProfileTopLevelShow from '../media_profiles/media_profile_top_level_show';

// blockUntilSettled/normalizeViewerContextOnFailure: true -- see with_v2_identity.jsx's module
// comment. This show page already blocks on its own entity resolution, so withholding the mount
// until identity has settled too costs nothing extra; normalizing viewerContext on a settled
// failure keeps a signed-in viewer from ever seeing a page that mixes an authenticated
// viewerContext with cleared identity globals.
const V1MediaProfileShow = withV2Identity(withV2Entity(MediaProfileTopLevelShow, {
  apiTable: 'media_profiles',
  idColumn: 'migrate_id',
  idPropName: 'mediaProfileId',
  narrowQuery: (query) => query.or('migrate_type.eq.Reporter,migrate_type.is.null'),
}), { blockUntilSettled: true, normalizeViewerContextOnFailure: true });

export default V1MediaProfileShow;
